export const getQualityIncidenceRowId = (row) => (
  row?.id ??
  row?.uuid ??
  row?.qualityIncidenceAffectedUuid ??
  row?.qualityIncidenceScopeUuid ??
  row?.qualityIncidenceScopeAffectedUuid ??
  null
)

export const filterDeletedRows = (data, deletedIds) => {
  const ids = new Set(deletedIds || [])
  if (ids.size === 0) return data

  const isDeleted = (row) => ids.has(getQualityIncidenceRowId(row))

  if (Array.isArray(data)) {
    return data.filter((row) => !isDeleted(row))
  }

  if (Array.isArray(data?.content)) {
    const filteredContent = data.content.filter((row) => !isDeleted(row))
    return {
      ...data,
      content: filteredContent,
      totalElements: Math.max(0, (data.totalElements || data.content.length) - (data.content.length - filteredContent.length))
    }
  }

  return data
}
